module.exports = __webpack_public_path__ + "img/shop-1688.5440c74a.png";